import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Vehicle } from './vehicle/vehicle.component'
import ImageMotorcycle from './assets/vn/motorcycle.svg'
import ImageTricycle from './assets/vn/tricycle.svg'
import ImageVan500 from './assets/vn/van500.svg'
import ImageVan1000 from './assets/vn/van1000.svg'
import ImageTruck500 from './assets/vn/truck500.svg'
import ImageTruck1000 from './assets/vn/truck1000.svg'
import ImageTruck1500 from './assets/vn/truck1500.svg'
import ImageTruck2000 from './assets/vn/truck2000.svg'

const VehicleListVN = ({ estimations, quoteInProgress }) => {
  const [t] = useTranslation()

  const motorcycleFee = estimations.motorcycle || t('text__body__minimum_fee__motocycle')
  const tricycleFee = estimations.tricycle || t('text__body__minimum_fee__tricycle')
  const van500Fee = estimations.van500 || t('text__body__minimum_fee__van_500kg')
  const van1000Fee = estimations.van1000 || t('text__body__minimum_fee__van_1t')
  const truck500Fee = estimations.truck500 || t('text__body__minimum_fee__truck_500kg')
  const truck1000Fee = estimations.truck1000 || t('text__body__minimum_fee__truck_1t')
  const truck1500Fee = estimations.truck1500 || t('text__body__minimum_fee__truck_1_5t')
  const truck2000Fee = estimations.truck2000 || t('text__body__minimum_fee__truck_2t')

  const defaultFee = Object.keys(estimations).length === 0

  return (
    <>
      <Vehicle
        image={ImageMotorcycle}
        name={t('common__vehicle__motorcycle')}
        description={t('text__body__vehicle_description__motorcycle')}
        fee={motorcycleFee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageTricycle}
        name={t('common__vehicle__tricycle')}
        description={t('text__body__vehicle_description__tricycle')}
        fee={tricycleFee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageVan500}
        name={t('common__vehicle__van_500kg')}
        description={t('text__body__vehicle_description__van_500kg')}
        fee={van500Fee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageVan1000}
        name={t('common__vehicle__van_1t')}
        description={t('text__body__vehicle_description__van_1t')}
        fee={van1000Fee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageTruck500}
        name={t('common__vehicle__truck_500kg')}
        description={t('text__body__vehicle_description__truck_500kg')}
        fee={truck500Fee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageTruck1000}
        name={t('common__vehicle__truck_1t')}
        description={t('text__body__vehicle_description__truck_1t')}
        fee={truck1000Fee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageTruck1500}
        name={t('common__vehicle__truck_1_5t')}
        description={t('text__body__vehicle_description__truck_1_5t')}
        fee={truck1500Fee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageTruck2000}
        name={t('common__vehicle__truck_2t')}
        description={t('text__body__vehicle_description__truck_2t')}
        fee={truck2000Fee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
    </>
  )
}

VehicleListVN.propTypes = {
  estimations: PropTypes.object,
  quoteInProgress: PropTypes.bool,
}

export { VehicleListVN }
